import React, { useState } from 'react'
import { Tabs } from 'antd';
import MemberEditHealth from './MembersEdit';
import PincodeEdit from './PincodeEdit';
export default function MemberEditTabs({setIsModalOpenMember}) {
    const [tabKey, setTabKey] = useState('1');

  const onTabChange = (key) => {
    console.log(key);
    setTabKey(key);
  };
    console.log(tabKey)
  return (
    <>
     <Tabs defaultActiveKey="1" centered onChange={onTabChange} activeKey={tabKey}>
    <Tabs.TabPane tab="Members" key="1">
      <MemberEditHealth setIsModalOpenMember={setIsModalOpenMember}/>
    </Tabs.TabPane>
    <Tabs.TabPane tab="Pincode" key="2">
      <PincodeEdit setTabKey={setTabKey}  setIsModalOpenMember={setIsModalOpenMember}/>
    </Tabs.TabPane>
  </Tabs>
    </>
  )
}

